import { render } from "./Sv053.vue?vue&type=template&id=3054f781&scoped=true"
import script from "./Sv053.vue?vue&type=script&lang=js"
export * from "./Sv053.vue?vue&type=script&lang=js"

import "./Sv053.vue?vue&type=style&index=0&id=3054f781&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3054f781"]])

export default __exports__